import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  categories: [],
  loading: false,
  selectedCategory: null,
  error: null,
  pagination: {
    totalPages: 0,
    totalElements: 0,
    currentPage: 0,
    pageSize: 10,
    isLastPage: false,
    isFirstPage: true,
  },
};

const mealCategorySlice = createSlice({
  name: "mealCategory",
  initialState,
  reducers: {
    fetchCategoriesStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchCategoriesSuccess(state, action) {
      state.categories = action.payload.categories;
      state.pagination = action.payload.pagination;
      state.loading = false;
      state.error = null;
    },
    fetchCategoriesFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },

    addCategoryStart(state) {
      state.loading = true;
      state.error = null;
    },
    addCategorySuccess(state, action) {
      state.loading = false;
      state.categories.unshift(action.payload);
      state.error = null;
    },
    addCategoryFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    deleteCategoryStart(state) {
      state.loading = true;
      state.error = null;
    },
    deleteCategorySuccess(state, action) {
      state.loading = false;
      state.categories = state.categories.filter(
        (category) => category.id !== action.payload
      );
      state.error = null;
    },
    deleteCategoryFailure(state, action) {
      state.loading = true;
      state.error = action.payload;
    },
    editCategoryStart(state) {
      state.loading = true;
      state.error = null;
    },
    editCategorySuccess(state, action) {
      state.loading = false;
      const updatedCategory = action.payload;
      const index = state.categories.findIndex(
        (cat) => cat.id === updatedCategory.id
      );
      if (index !== -1) {
        state.categories[index] = updatedCategory;
      }
      state.error = null;
    },
    editCategoryFailure(state, action) {
      state.loading = true;
      state.error = action.payload;
    },

    getCategoryByIdStart(state) {
      state.loading = false;
      state.error = null;
      state.selectedCategory = null;
    },
    getCategoryByIdSuccess(state, action) {
      state.loading = false;
      state.selectedCategory = action.payload;
      state.error = null;
    },
    getCategoryByIdFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetCategories(state) {
      state.categories = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  fetchCategoriesStart,
  fetchCategoriesSuccess,
  fetchCategoriesFailure,
  addCategoryStart,
  addCategoryFailure,
  addCategorySuccess,
  deleteCategoryFailure,
  deleteCategoryStart,
  deleteCategorySuccess,
  editCategoryFailure,
  editCategoryStart,
  editCategorySuccess,
  getCategoryByIdFailure,
  getCategoryByIdStart,
  getCategoryByIdSuccess,
  resetCategories,
} = mealCategorySlice.actions;

export default mealCategorySlice.reducer;
